import { createContext } from 'react'

const CompanyFragilityContext = createContext()

export default CompanyFragilityContext
